import { styled } from "@vitality-ds/system";
import { BaseButtonWrapper } from "./styles/BaseButtonWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var ButtonWrapper = styled("div", BaseButtonWrapper);